import { PendingChangesGuard } from './../../services/dirty-nav-guard';
import { LogService } from './../../services/logging.service';
import { WMSService } from './../../services/wms.service';
import { AcumaticaService } from './../../acumatica/acumatica.service';
import { ScannerManagerService } from './../../directives/scan-input.directive';
import { Component } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.css']
})
export class AppSettingsComponent {

  constructor(
    public scanMgr: ScannerManagerService,
    public wms: WMSService,
    public acumatica: AcumaticaService,
    public logging: LogService
  ) {
  }

  get DirtyNavProtectionDisabled() { return PendingChangesGuard.DirtyNavProtectionDisabled; }
  set DirtyNavProtectionDisabled(value: boolean) { PendingChangesGuard.DirtyNavProtectionDisabled = value; }

  get OverrideRepWhseID(): string | null { return localStorage.getItem('OverrideRepWhseID'); }
  set OverrideRepWhseID(value: string | null) {
    if (value === null)
      localStorage.removeItem('OverrideRepWhseID');
    else
      localStorage.setItem('OverrideRepWhseID', value.toUpperCase());
  }
}
